import { render, staticRenderFns } from "./myCourseDetail.vue?vue&type=template&id=3fc49f12&scoped=true"
import script from "./myCourseDetail.vue?vue&type=script&lang=js"
export * from "./myCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./myCourseDetail.vue?vue&type=style&index=0&id=3fc49f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc49f12",
  null
  
)

export default component.exports